var _defs, _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2889_5956"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "calendar-alt",
    rx: 8,
    width: 24,
    height: 24,
    transform: "translate(4.000000 4.000000)",
    fill: "white",
    fillOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Link",
    rx: 5.5,
    width: 31,
    height: 31,
    transform: "translate(0.500000 0.500000)",
    fill: "#2D303E",
    fillOpacity: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Link",
    rx: 5.5,
    width: 31,
    height: 31,
    transform: "translate(0.500000 0.500000)",
    stroke: "#718EBF",
    strokeOpacity: 1,
    strokeWidth: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2889_5956)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M7 13L25 13M21.79 9C22.91 9 23.48 9 23.9 9.21C24.28 9.4 24.58 9.71 24.78 10.09C25 10.51 25 11.07 25 12.2L25 21.8C25 22.92 25 23.48 24.78 23.9C24.58 24.28 24.28 24.59 23.9 24.78C23.48 25 22.91 25 21.79 25L10.2 25C9.08 25 8.51 25 8.09 24.78C7.71 24.59 7.41 24.28 7.21 23.9C7 23.48 7 22.92 7 21.8L7 12.2C7 11.07 7 10.51 7.21 10.09C7.41 9.71 7.71 9.4 8.09 9.21C8.51 9 9.08 9 10.2 9L21.79 9ZM11 7L11 9M21 7L21 9M10 17L12 17M10 21L12 21M15 17L17 17M15 21L17 21M20 17L22 17M20 21L22 21",
    stroke: "#718EBF",
    strokeOpacity: 1,
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.65505b7f405dfb0ddcea34aa8f0c589a.svg";
export { ForwardRef as ReactComponent };